import ContactForm from "./ContactForm";
import LandingPage from "./LandingPage";
import Navbar from "./Navbar";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import InnerLandingPage from "./InnerLandingPages/InnerLandingPage";
import WhatsAppIcon from "./WhatsAppIcon";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { ContentProvider } from "./ContentContext";
import About from "./About";



function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/about" element={<About />} />
        <Route path="/freightForwarding" element={<InnerLandingPage Name={'freightForwarding'} />} />
        <Route path="/Logistics" element={<InnerLandingPage Name={'Logistics'} />} />
        <Route path="/OverseasEmployment" element={<InnerLandingPage Name={'OverseasEmployment'} />} />
        <Route path="/Insurance" element={<InnerLandingPage Name={'Insurance'} />} />
        <Route path="/FoodProcessing" element={<InnerLandingPage Name={'FoodProcessing'} />} />
        <Route path="/Education" element={<InnerLandingPage Name={'Education'} />} />
      </Routes>
    </AnimatePresence>
  );
}


function App() {
  library.add(fas);
  return (
    <ContentProvider>
      <Router>
        <Navbar />
        <WhatsAppIcon />
        <AnimatedRoutes />
      </Router>
    </ContentProvider>
  );
}

export default App;
